<template>
  <market-base
    ref="marketBase"
    :get-data="getData"
    :collections="formattedCollections"
    :default-collection-address="filteredCollectionAddress"
    @set-filtered-collection-address="setFilteredCollectionAddress"
    @clearExtendFilter="clearExtendFilter()"
    :filters="availableFilters"
  >
    <template #banner-game>
      <img :src="bunicornGameConfig.banner" />
    </template>
    <template #game-statistics>
      <overview-section
        :number-of-item="statistics.numberOfItem"
        :number-of-owner="statistics.numberOfOwner"
        :number-of-trade="statistics.numberOfTrade"
      />
    </template>
    <template #extend-searching-bar>
      <CustomCheckbox
        ref="myNftCheckBox"
        v-model="isSeller"
        :checkboxLabel="'My ' + nftCollectionName"
      />
    </template>
    <template #grid-data="props">
      <bunicorn-nft-card
        v-if="nftCollectionName === 'Bunicorn'"
        :nftData="formatNftCardData(props.item)"
      />
      <trainer-nft-card
        v-if="nftCollectionName === 'Trainer'"
        :nftData="formatNftCardData(props.item)"
      />
    </template>
  </market-base>
</template>

<script>
import MarketBase from '@/views/Marketplace/MarketBase.vue';
import config from '@/config';
import OverviewSection from '@/components/BaseComponents/OverviewSection';
import rf from '@/requests/RequestFactory';
import { cleanObject, getSellMethod, getNftTax } from '@/helpers/index';
import _ from 'lodash';
import { mapState } from 'vuex';
import CustomCheckbox from '@/components/BaseComponents/CustomCheckbox.vue';
import BunicornNftCard from '@/components/BunicornGame/BunicornNftCard.vue';
import TrainerNftCard from '@/components/BunicornGame/TrainerNftCard.vue';

export default {
  name: 'MarketBunicornGame',
  components: {
    OverviewSection,
    MarketBase,
    CustomCheckbox,
    BunicornNftCard,
    TrainerNftCard
  },
  data() {
    return {
      statistics: {
        numberOfItem: 0,
        numberOfOwner: 0,
        numberOfTrade: 0
      },
      collectionType: 1,
      collections: [],
      filteredCollectionAddress: '',
      dutchAuctionPrices: {},
      isSeller: false
    };
  },
  computed: {
    ...mapState('auth', ['address']),
    bunicornGameConfig() {
      const projects = config.projects;
      return projects.bunicornGame;
    },
    trainerNftAddress() {
      if (!this.bunicornGameConfig) {
        return '';
      }
      const trainerConfig = _.find(
        this.bunicornGameConfig.collections || [],
        collection => {
          return collection.nftName === 'Trainer';
        }
      );
      return trainerConfig ? trainerConfig.nftContract : '';
    },
    formattedCollections() {
      if (!this.collections) {
        return [];
      }
      return this.collections.map(collection => {
        return {
          nftName: collection.name,
          nftContract: collection.nftContract
        };
      });
    },
    availableFilters() {
      const filteredCollectionAddress = this.filteredCollectionAddress || '';
      if (
        filteredCollectionAddress.toLowerCase() ===
        this.trainerNftAddress.toLowerCase()
      ) {
        return ['sellMethod', 'currency', 'genres'];
      }
      return ['sellMethod', 'currency', 'genres'];
    },
    nftCollectionName() {
      if (!this.bunicornGameConfig) {
        return '';
      }
      const filteredCollectionAddress = this.filteredCollectionAddress || '';
      const nftCollection = _.find(
        this.bunicornGameConfig.collections || [],
        collection => {
          return collection.nftContract === filteredCollectionAddress;
        }
      );
      return nftCollection ? nftCollection.nftName : '';
    }
  },
  watch: {
    formattedCollections() {
      if (!this.formattedCollections) {
        return (this.filteredCollectionAddress = '');
      }
      const [{ nftContract }] = this.formattedCollections;
      this.filteredCollectionAddress = nftContract;
      if (this.$refs.marketBase) {
        this.$refs.marketBase.filter({
          nftContract: this.filteredCollectionAddress,
          currency: config.defaultCurrency.address
        });
      }
    },
    isSeller() {
      this.$refs.marketBase.fetch();
    }
  },
  mounted() {
    this.init();
    this.$nextTick(() => {
      this.fetchCollections();
    });
  },
  methods: {
    setFilteredCollectionAddress(address) {
      this.filteredCollectionAddress = address;
      this.$nextTick(() => {
        console.log('filterMarketBase');
        this.$refs.marketBase.filter({
          nftContract: this.filteredCollectionAddress,
          currency: config.defaultCurrency.address
        });
      });
    },
    async fetchCollections() {
      const params = {
        group: this.bunicornGameConfig.keyGroup
      };
      const res = await rf.getRequest('CollectionRequest').getList(params);
      this.collections = res;
    },
    cleanObject,
    getSellMethod,
    getNftTax,
    clearExtendFilter() {
      this.isSeller = false;
      this.$refs.myNftCheckBox.isChecked = false;
    },
    formatNftCardData(data) {
      const metaData = data.metaData || {};
      return {
        nftContract: data.nftContract,
        nftId: data.nftId,
        nftImage: metaData.image,
        nftName: metaData.name,
        nftAttributes: metaData.attributes,
        sellMethod: this.getSellMethod(data.sellMethod),
        price: data.price,
        sellerAddress: data.sellerAddress,
        collectionType: this.collectionType,
        currencyAddress: data.currency
      };
    },
    getData(params) {
      const nftContractAddr = params.nftContract;
      if (!nftContractAddr) {
        return null;
      }
      this.collectionType = params.collection_type;
      this.getStatistics(nftContractAddr);
      const newParams = {
        ...params,
        sellerAddress: this.isSeller ? this.address : ''
      };
      // params.availableAt = Math.floor(new Date().valueOf() / 1000);
      if (params.collection_type === 2) {
        return rf
          .getRequest('GameMarketplaceRequest')
          .getListBundle(nftContractAddr, this.cleanObject(newParams));
      }
      return rf
        .getRequest('GameMarketplaceRequest')
        .getList(this.cleanObject(newParams));
    },
    async getStatistics(nftContractAddr) {
      const res = await rf
        .getRequest('GameMarketplaceRequest')
        .getStatistics(nftContractAddr);
      this.statistics = {
        numberOfItem: res.items || 0,
        numberOfOwner: res.owners || 0,
        numberOfTrade: res.traded || 0
      };
    },
    init() {
      this.setupMarketPlaceContract();
    },
    setupMarketPlaceContract() {
      this.$refs.marketBase.setupMarketPlaceContract({
        commonMarketPlace: this.bunicornGameConfig.marketplaceAddress,
        auctionMarketPlace: config.addresses.bunicornNFTAuctionMarketplace
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/config/_variables';
.sidebar {
  display: none;
}
.filter-btn {
  display: none;
}
.body {
  margin: 40px auto;
  display: flex;
  flex-wrap: wrap;

  .arrow-left {
    position: absolute;
    right: 30px;
    top: 35px;
  }
  .market-items-wrapper {
    width: calc(100% - 30px - 242px);
    margin-left: 30px;
    .game-market-banner {
      width: -webkit-fill-available;
    }
    .market-overview {
      margin: 30px auto 0;
    }

    .search-sort-bar {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      .input-wrapper {
        display: flex;
        .custom-dropdown {
          width: 160px;
        }
        > div {
          margin-right: 10px;
        }
      }
    }
    .artwork-grid {
      margin-top: 20px;
      display: grid;
      grid-template-areas: 'a a a a';
      grid-auto-columns: 25%;
      grid-row-gap: 16px;
      .grid-item-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .market-pagination {
      margin-top: 26px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
@media (max-width: $breakpoint-desktop) {
  .filter-btn {
    display: block;
    max-height: 48px;
    margin-left: 16px;
  }
  .body {
    .filter {
      display: none;
    }
    .market-items-wrapper {
      width: 100%;
      margin: auto;
      .search-sort-bar {
        .input-wrapper {
          flex-wrap: wrap;
          div {
            margin: 8px 0;
          }
        }

        .clear-btn {
          white-space: nowrap;
          max-height: 48px;
        }
      }
      .artwork-grid {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .sidebar {
    display: block;
    position: absolute;
    bottom: 50px;
    left: 0;
    right: 0;
    z-index: 1040;
    margin: auto;
  }
}
@media (max-width: $breakpoint-macbook) {
  .body {
    .market-items-wrapper {
      .artwork-grid {
        grid-template-columns: auto auto auto;
      }
    }
  }
}
@media (max-width: $breakpoint-mobile) {
  .body {
    .market-items-wrapper {
      .market-overview {
        flex-wrap: wrap;
        width: 100%;
        justify-content: center;
        ::v-deep .section {
          width: 150px;
          text-align: center;
        }
      }
      .search-sort-bar {
        flex-wrap: wrap;
        justify-content: center;
        .input-wrapper {
          flex-wrap: wrap;
          ::v-deep .input-search-wrapper {
            width: 100%;
            input {
              width: 100%;
            }
          }
          .sort {
            width: 100%;
          }
          div {
            margin: 8px;
          }
        }
        .clear-btn {
          margin: 8px;
        }
      }
      .artwork-grid {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
      }
      .custom-pagination {
        justify-content: center;
      }
    }
  }
}
</style>
